/** mobxRoot */
const storeObj = {};

/**
 * 客户端 Initialize the store
 * @param {*} key MobxStoreKey
 * @param {*} Store storeClass
 * @param {*} initialData 初始化值
 * @returns
 */
export function initializeClientStore(key, Store, initialData = null) {
  const _store = storeObj[key] ?? new Store(storeObj);

  // If your page has Next.js data fetching methods that use a Mobx store, it will
  // get hydrated here, check `pages/ssg.js` and `pages/ssr.js` for more details
  if (initialData) {
    _store.hydrate(initialData);
  }

  // Create the store once in the client
  if (!storeObj[key]) {
    storeObj[key] = _store;
  }

  return _store;
}

export function initializeServerStore(stores, initialData = null) {
  const storeObj = {};
  for (const key in stores) {
    const _store = new stores[key](storeObj);
    if (initialData?.[key]) {
      _store.hydrate(initialData[key]);
    }
    storeObj[key] = _store;
  }
  return storeObj;
}
